import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { path: "/", label: "Home" },
  { path: "/events", label: "Events" },
  { path: "/services", label: "Services" },
  { path: "/competitions", label: "Competitions" },
  { path: "/app", label: "Get App" },
  { path: "/about", label: "About Us" },
];

const HypenaNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location.pathname]);

  const base = process.env.PUBLIC_URL || "";

  return (
    <>
      <header className={`hn-nav ${scrolled ? "scrolled" : ""}`}>
        <div className="hn-nav-inner">
        <Link to="/" className="hn-nav-logo">
          HypeNa
        </Link>
        <button
          type="button"
          className="hn-nav-toggle"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? "bi bi-x-lg" : "bi bi-list"} />
        </button>
        <ul className={`hn-nav-links ${menuOpen ? "open" : ""}`}>
          {navItems.map(({ path, label }) => {
            return (
              <li key={path}>
                <NavLink
                  to={path}
                  exact={path === "/"}
                  activeClassName="active"
                >
                  {label}
                </NavLink>
              </li>
            );
          })}
        </ul>
        </div>
      </header>
      <div className="hn-nav-spacer" />
    </>
  );
};

export default HypenaNav;
